import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { NetworkRequiredPageRoutingModule } from './network-required-routing.module';

import { NetworkRequiredPage } from './network-required.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    NetworkRequiredPageRoutingModule,
  ],
  declarations: [NetworkRequiredPage],
})
export class NetworkRequiredPageModule {}
